var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgDAhuSignalLine23 = function SvgDAhuSignalLine23(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 684 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 684,
    height: 480,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 270,
    width: 2,
    height: 54,
    fill: "#1c9d5b"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "218 374 178 374 178 336 180 336 180 372 218 372 218 374",
    fill: "#1c9d5b"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 372,
    width: 7,
    height: 2,
    fill: "#1c9d5b"
  }))));
};
export default SvgDAhuSignalLine23;